import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import uuid from 'uuid/v4'
// import image_db from './content/image_db_local.json'
// import term_db from './content/term_db_local.json'
import image_db_dict from './content/image_db_dict_3.json'
import term_db_dict from './content/term_db_dict_3.json'
import _ from 'underscore'
const store = new Vuex.Store({
  state: {
    sessionId: null,
    termsOfService: false,
    appVersion: 1.27,
    //Image States
    images: null,
    imagesRemaining: null,
    quizImages: null,
    imageDict: image_db_dict,
    imageCountTotal: Object.keys(image_db_dict).length,
    //Term States
    terms: null,
    termsRemaining: null,
    quizTerms: null,
    termsDict: term_db_dict,
    termCountTotal: Object.keys(term_db_dict).length,

    //SETUP
    combined: null
  },
  mutations: {
    sessionIdSet(state, val) {
      state.sessionId = val
    },
    termsOfServiceSet(state, val) {
      state.termsOfService = val
    },
    //Image Mutations
    imagesSet(state, val) {
      state.images = val
    },
    imagesRemainingSet(state, val) {
      state.imagesRemaining = val
    },
    quizImagesSet(state, val) {
      state.quizImages = val
    },
    //Term Murations
    termsSet(state, val) {
      state.terms = val
    },
    termsRemainingSet(state, val) {
      state.termsRemaining = val
    },
    quizTermsSet(state, val) {
      state.quizTerms = val
    }
  },
  actions: {

    sessionIdCreate() {
      store.commit('sessionIdSet', uuid())
    },
    termsOfServiceAcknowledged() {
      store.commit('termsOfServiceSet', true)
    },
    //Image Actions
    initializedImages() {
      //store.commit('imagesSet', image_db)
      store.commit('imagesSet', Object.keys(image_db_dict))
    },
    serveImages(context, val) {
      let subset
      let remaining
      if (val.includes("All") ) {
        subset = this.state.images
        remaining = []
      } else {
        subset = _.sample(this.state.images, val)
        remaining = _.difference(this.state.images, subset)
      }
      store.commit('imagesRemainingSet', remaining)
      store.commit('quizImagesSet', subset)
    },
    removeCompletedImages() {
      store.commit('imagesSet', this.state.imagesRemaining)
      store.commit('imagesRemainingSet', null)
    },
    //Term Actions
    initializedTerms() {
      //store.commit('termsSet', term_db)
      store.commit('termsSet', Object.keys(term_db_dict))
    },
    serveTerms(context, val) {
      let subset
      let remaining
      if (val.includes("All")) {
        subset = this.state.terms
        remaining = []
      } else {
        subset = _.sample(this.state.terms, val)
        remaining = _.difference(this.state.terms, subset)
      }
      store.commit('termsRemainingSet', remaining)
      store.commit('quizTermsSet', subset)
    },
    removeCompletedTerms() {
      store.commit('termsSet', this.state.termsRemaining)
      store.commit('termsRemainingSet', null)
    },
    preloadImages(context, val) {
      let images = {}
      for (let item in this.state.imageDict) {
        images[item] = new Image()
        images[item].src = this.state.imageDict[item].image
      }
      console.log('images_loaded')
    },
    buildSet(context, val) {
      let final = {}
      let images = {}
      for (let item in this.state.imageDict) {
        final[item] = this.state.imageDict[item]
        final[item].type = 'image'
      }
      for (let item in this.state.termsDict) {
        final[item] = this.state.termsDict[item]
        final[item].type = 'term'
      }
      this.state.combined = final
    },
    restoreData(context, val) {
      if ('iosDataLoad' in window) { //check if data is stored and being emitted
        let parsed = JSON.parse(window.iosDataLoad.split("'")[1])
        //store.commit('termsOfServiceSet', parsed.termsOfService)
        //disable the terms of service restoration
        store.commit('imagesSet', parsed.images)
        store.commit('termsSet', parsed.terms)

      }
      else {
        store.dispatch("restoreCookie")
      }
    },

    setCookie(context, val) {
      console.log('setCookie', val)
      var d = new Date();
      d.setTime(d.getTime() + (120 *24*60*60*1000)); //120 days
      var expires = "expires="+ d.toUTCString();
      console.log(val)
      document.cookie = 'practiceData' + "=" + val + ";" + expires + ";path=/";
    },
    deleteCookie(context) {
      var d = new Date();
      d.setTime(d.getTime() - (120 *24*60*60*1000)); //120 days expired
      var expires = "expires="+ d.toUTCString();
      document.cookie = 'practiceData' + "=" + ";" + expires + ";path=/";
    },

    restoreCookie(context) {
      let result = document.cookie
      let s = result.split(';')
      let dict = {}
      s.forEach(item => {
        let e = item.split("=")
        dict[e[0].trim()] = e[1]
      })
      if ('practiceData' in dict) {
        let parsed = JSON.parse(dict['practiceData'])
        store.commit('imagesSet', parsed.images)
        store.commit('termsSet', parsed.terms)
      }

    },


  },
})

store.dispatch("sessionIdCreate")
store.dispatch("initializedImages")
store.dispatch("initializedTerms")
store.dispatch("restoreData")
store.dispatch("preloadImages")
store.dispatch("buildSet")
store.dispatch("restoreCookie")
export default store
